import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import excel from 'assets/images/icons/excel.svg';
import ErrorModal from 'pages/comptroller/ErrorModal';
import { Button, Col, Flex, Form, Popover, Row, Upload } from 'antd';
import { CheckSquareOutlined, InboxOutlined } from '@ant-design/icons';
import { exportWithData, handleFileUpload } from 'pages/globals/FileUploadExcel';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const { Dragger } = Upload;

function EmployeeBulkUpdate({ employeeTableList, existingEmployeeIdDataMap, setShowModal, setSubmitExcelData, setModalInfo }) {
	const theme = useTheme();
	const [excelTable, setExcelTable] = useState([]);
	const [fileSubmitButton, setFileSubmitButton] = useState(true);
	const [exportData, setExportData] = useState([]);
	let existingEmailData = [];
	let existingEmailDataMap = [];
	const exportColumns = [
		'employeeId',
		'initials',
		'firstName',
		'middleName',
		'lastName',
		'email',
		'mobile',
		'designation',
		// jobBand: "",
		// payGrade: "",
		// positionId: "",
	];
	const [show, setShow] = useState(false);
	const columns = [
		{
			id: 'serial',
			align: 'center',
			disablePadding: true,
			label: 'Row No',
		},
		{
			id: 'employeeId',
			align: 'center',
			disablePadding: true,
			label: 'Employee ID',
		},
		{
			id: 'layer',
			align: 'center',
			disablePadding: true,
			label: 'Name',
		},
		{
			id: 'levelName',
			align: 'center',
			disablePadding: true,
			label: 'Email',
		},
		{
			id: 'funtionName',
			align: 'center',
			disablePadding: true,
			label: 'Mobile',
		},
		// {
		//   id: "parent",
		//   align: "center",
		//   disablePadding: true,
		//   label: "HR Position Code",
		// },
		{
			id: 'designation',
			align: 'center',
			disablePadding: true,
			label: 'Designation',
		},
		// {
		//   id: "functionId",
		//   align: "center",
		//   disablePadding: true,
		//   label: "Job Band",
		// },
		// {
		//   id: "pay_grade",
		//   align: "center",
		//   disablePadding: true,
		//   label: "Pay Grade",
		// },
		{
			id: 'validation',
			align: 'center',
			disablePadding: true,
			label: 'Validation',
		},
	];

	useEffect(() => {
		if (employeeTableList) {
			let arr = [];
			employeeTableList?.map((hrmaster) => {
				arr.push({
					employeeId: hrmaster?.employeeId,
					initials: hrmaster?.entityInitials,
					firstName: hrmaster?.entityFirstName,
					middleName: hrmaster?.entityMiddleName,
					lastName: hrmaster?.entityLastName,
					email: hrmaster?.entityEmail,
					mobile: hrmaster?.entityPhoneNumber,
					designation: hrmaster?.designation,
				});
				return hrmaster;
			});
			setExportData(arr);
		}
	}, [employeeTableList]);
	// submit state
	const [excelData, setExcelData] = useState([]);

	// onchange event

	const isEmailValid = (email) => {
		// Regular expression for a basic email validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(email)) {
			return false;
		}

		const domain = email.split('@')[1];
		const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		return domainRegex.test(domain);
	};

	const handleEmailExcel = (data) => {
		let res = {
			input: '',
			output: '',
			message: '',
			statusCode: '',
			isIssue: '',
		};
		if (data === undefined || data === null || data === '') {
			res.input = data;
			res.output = '';
			res.message = 'Email is Empty';
			res.statusCode = '501';
			res.isIssue = true;
			return res;
		}
		if (isEmailValid(data)) {
			if (existingEmailData[data] === undefined) {
				existingEmailData[data] = data;
				res.input = data;
				res.output = data;
				res.message = 'ok';
				res.statusCode = '200';
				res.isIssue = false;
				return res;
			} else {
				res.input = data;
				res.output = data;
				res.message = 'Duplicate Email';
				res.statusCode = '503';
				res.isIssue = true;
				return res;
			}
		} else {
			res.input = data;
			res.output = data;
			res.message = 'Invalid Email';
			res.statusCode = '504';
			res.isIssue = true;
			return res;
		}
	};

	let employeeIdMapData = [];

	const handleExccelEmployeeId = (data) => {
		let res = {
			input: '',
			output: '',
			message: '',
			statusCode: '',
			isIssue: '',
		};
		if (data === undefined || data === null || data === '') {
			res.input = data;
			res.output = '';
			res.message = 'Employee Id is Empty';
			res.statusCode = '501';
			res.isIssue = true;
			return res;
		}
		if (employeeIdMapData[data] === undefined) {
			employeeIdMapData[data] = data;
			res.input = data;
			res.output = data;
			res.message = 'ok';
			res.statusCode = '200';
			res.isIssue = false;
			return res;
		} else {
			res.input = data;
			res.output = data;
			res.message = 'Duplicate Employee Id';
			res.statusCode = '503';
			res.isIssue = true;
			return res;
		}
	};

	const validationData = (
		emailValidationResult,
		// positionIdValidationResult
		epmloyeeIdResult
	) => {
		let arr = [];
		let errorCount = 0;
		if (emailValidationResult?.isIssue) {
			arr.push({
				input: emailValidationResult?.input,
				field: 'Email',
				output: emailValidationResult?.output,
				message: emailValidationResult?.message,
				statusCode: emailValidationResult?.statusCode,
				isIssue: emailValidationResult?.isIssue,
			});
		}
		if (epmloyeeIdResult?.isIssue) {
			arr.push({
				input: epmloyeeIdResult?.input,
				field: 'Employee Id',
				output: epmloyeeIdResult?.output,
				message: epmloyeeIdResult?.message,
				statusCode: epmloyeeIdResult?.statusCode,
				isIssue: epmloyeeIdResult?.isIssue,
			});
		}
		for (let i = 0; i < arr.length; i++) {
			if (arr[i]?.isIssue) {
				errorCount++;
			}
		}
		if (errorCount > 0) {
			setFileSubmitButton(true);
			return {
				input: arr,
				output: '',
				message: 'errors',
				statusCode: '500',
				isIssue: true,
			};
		} else {
			setFileSubmitButton(false);
			return {
				input: '',
				output: '',
				message: 'ok',
				statusCode: '200',
				isIssue: false,
			};
		}
	};

	const validateData = (data) => {
		for (let i = 0; i < data?.length; i++) {
			let obj = data[i];
			const keys = Object.keys(obj);
			for (let j = 0; j < exportColumns?.length; j++) {
				if (!keys.includes(exportColumns[j])) {
					data[i][exportColumns[j]] = '';
				}
			}
		}
		setExcelData(data);
		for (let i = 0; i < employeeTableList?.length; i++) {
			existingEmailDataMap[employeeTableList[i]?.entityEmail] = employeeTableList[i];
		}
		//console.log("existingEmailDataMap", existingEmailDataMap);
		const arr = [];
		for (let i = 0; i < data?.length; i++) {
			let hee = handleEmailExcel(data[i]?.email);
			let fullName = data[i]?.middleName
				? (data[i]?.firstName ?? '') + ' ' + (data[i]?.middleName ?? '') + ' ' + (data[i]?.lastName ?? '')
				: (data[i]?.firstName ?? '') + ' ' + (data[i]?.lastName ?? '');
			// let hpp = handlePositionIdExcel(data[i]?.positionId);
			let hei = handleExccelEmployeeId(data[i]?.employeeId);
			let vd = validationData(hee, hei);
			arr.push({
				id: existingEmployeeIdDataMap[data[i]?.employeeId]?.[0]?.id ?? '',
				b64PicProfile: existingEmployeeIdDataMap[data[i]?.employeeId]?.[0]?.b64PicProfile ?? [],
				employeeId: hei,
				entityInitials: data[i]?.initials,
				entityFirstName: data[i]?.firstName,
				entityMiddleName: data[i]?.middleName ?? '',
				entityLastName: data[i]?.lastName,
				entityFullName: fullName,
				entityEmail: hee,
				entityPhoneNumber: data[i]?.mobile ? '0' + data[i]?.mobile : '',
				designation: data[i]?.designation,
				// jobBand: data[i]?.jobBand,
				// payGrade: data[i]?.payGrade,
				// positionCode: hpp,
				validation: vd,
			});
		}
		for (let i = 0; i < arr?.length; i++) {
			if (arr[i]?.validation?.isIssue === true) {
				setFileSubmitButton(true);
				break;
			} else {
				setFileSubmitButton(false);
			}
		}
		setExcelTable(arr);
	};
	const handleExcelSubmit = (data) => {
		setSubmitExcelData(data);
		setModalInfo({
			head: 'HR Master',
			action: 'submit',
		});
		setShowModal(true);
		setShow(false);
	};
	// const onFinish = (values) => {
	//   values = excelData;
	// };
	// const onFinishFailed = (errorInfo) => {
	//   console.log('Failed:', errorInfo);
	// };

	return (
		<Form
			name="basic"
			layout="vertical"
			labelCol={{
				span: 12,
			}}
			wrapperCol={{
				span: 24,
			}}
			// onFinish={onFinish}
			// onFinishFailed={onFinishFailed}
		>
			<Row gutter={[24, 24]}>
				<Col xs={24} sm={12} md={12} xl={16}>
					<p style={{ paddingLeft: '20px' }}>
						To download a demo <img src={excel} alt="excel" width={22} style={{ margin: '0 5px' }} /> file{' '}
						<Button
							size="small"
							type="dashed"
							onClick={(e) => {
								e.preventDefault();
								exportWithData(exportData, 'HrMasterBulkUpdate.xlsx', exportColumns);
							}}
							style={{ color: '#1677ff', borderColor: '#1677ff' }}
						>
							Click Here
						</Button>
					</p>
				</Col>
				<Col xs={24} sm={24} md={24} xl={24}>
					<Form.Item
						rules={[
							{
								required: true,
							},
						]}
					>
						{!show && (
							<Dragger
								name="file"
								// action="/your-upload-endpoint" // Replace with your actual upload endpoint
								customRequest={({ file }) => {
									handleFileUpload(file, validateData, setShow);
								}}
								showUploadList={false}
								accept=".xlsx, .xls" // Specify the accepted file types (Excel files)
							>
								<p className="ant-upload-drag-icon">
									<InboxOutlined />
								</p>
								<p className="ant-upload-text">Click or drag Excel file to this area to upload</p>
								<p className="ant-upload-hint">Support for .xlsx and .xls files.</p>
							</Dragger>
						)}
						<br></br>
						{show && excelData && (
							<Box>
								<TableContainer
									sx={{
										width: '100%',
										overflowX: 'auto',
										position: 'relative',
										display: 'block',
										maxWidth: '100%',
										'& td, & th': { whiteSpace: 'nowrap' },
									}}
								>
									<Table
										aria-labelledby="tableTitle"
										sx={{
											'& .MuiTableCell-root:first-of-type': {
												pl: 2,
											},
											'& .MuiTableCell-root:last-of-type': {
												pr: 3,
											},
										}}
									>
										<TableHead>
											<TableRow style={{ backgroundColor: '#e5e5e5' }}>
												{columns.map((headCell, index) => (
													<TableCell
														key={index}
														align={headCell.align || 'left'}
														padding={headCell.disablePadding ? 'none' : 'normal'}
													>
														{headCell.label === 'Row No' && (
															<img src={excel} alt="excel" width={22} style={{ marginRight: '5px' }} />
														)}{' '}
														{headCell.label}
													</TableCell>
												))}
											</TableRow>
										</TableHead>
										<TableBody>
											{excelTable?.map((hrmaster, index) => {
												return (
													<TableRow
														hover
														role="checkbox"
														sx={{
															'&:last-child td, &:last-child th': {
																border: 0,
															},
														}}
														tabIndex={-1}
														key={index}
													>
														<TableCell align="center">{index + 2}</TableCell>
														<TableCell align="center">
															<div
																style={{
																	border:
																		hrmaster?.employeeId?.isIssue && hrmaster?.employeeId?.input?.length
																			? '2px solid red'
																			: '',
																}}
															>
																{hrmaster?.employeeId?.output
																	? hrmaster?.employeeId?.output
																	: hrmaster?.employeeId?.input}{' '}
															</div>{' '}
														</TableCell>
														<TableCell align="center">{hrmaster?.entityFullName}</TableCell>
														<TableCell align="center">
															<div
																style={{
																	border:
																		hrmaster?.entityEmail?.isIssue && hrmaster?.entityEmail?.input?.length
																			? '2px solid red'
																			: '',
																}}
															>
																{hrmaster?.entityEmail?.output
																	? hrmaster?.entityEmail?.output
																	: hrmaster?.entityEmail?.input}{' '}
															</div>{' '}
														</TableCell>
														<TableCell align="center"> {hrmaster?.entityPhoneNumber} </TableCell>
														{/* <TableCell key={hrmaster?.id} align="center">
                                  <div
                                    style={{
                                      border:
                                        hrmaster?.positionCode?.isIssue &&
                                          hrmaster?.positionCode?.input?.length
                                          ? "2px solid red"
                                          : "",
                                    }}
                                  >
                                    {hrmaster?.positionCode?.isIssue
                                      ? hrmaster?.positionCode?.message
                                      : hrmaster?.positionCode?.output}{" "}
                                  </div>{" "}
                                </TableCell> */}
														<TableCell align="center"> {hrmaster?.designation} </TableCell>
														{/* <TableCell key={hrmaster?.id} align="center">
                                  {hrmaster?.jobBand}{" "}
                                </TableCell> */}
														{/* <TableCell key={hrmaster?.id} align="center">
                                  {hrmaster?.payGrade}
                                </TableCell> */}
														<TableCell align="center">
															{' '}
															{hrmaster?.validation?.isIssue === false ? (
																<CheckSquareOutlined
																	size="large"
																	style={{
																		fontSize: '20px',
																		color: theme.palette.lynTheme.success,
																	}}
																/>
															) : (
																<>
																	<Popover
																		placement="topLeft"
																		trigger="focus"
																		content={<ErrorModal modalData={hrmaster?.validation?.input} />}
																	>
																		<Button
																			style={{
																				backgroundColor: theme.palette.lynTheme.delete,
																				marginRight: '10px',
																			}}
																			type="primary"
																		>
																			Show Errors
																		</Button>
																	</Popover>
																</>
															)}
														</TableCell>
													</TableRow>
												);
											})}
										</TableBody>
									</Table>
								</TableContainer>
							</Box>
						)}
					</Form.Item>
				</Col>
				<Col xs={24} sm={24} md={24} xl={24}>
					<Flex justify="flex-end" align="flex-end">
						{show && (
							<>
								{fileSubmitButton && (
									<Button
										style={{
											backgroundColor: theme.palette.lynTheme.success,
											marginRight: '10px',
										}}
										type="primary"
										onClick={(e) => {
											e.preventDefault();
											validateData(excelData);
										}}
									>
										Revalidate
									</Button>
								)}
								<Button
									style={{
										backgroundColor: theme.palette.lynTheme.delete,
										marginRight: '10px',
									}}
									type="primary"
									onClick={(e) => {
										e.preventDefault();
										setExcelTable([]);
										setShow(false);
									}}
								>
									Cancel
								</Button>
								<Button
									disabled={fileSubmitButton}
									style={{
										backgroundColor: fileSubmitButton ? '' : theme.palette.lynTheme.submit,
									}}
									type="primary"
									onClick={(e) => {
										e.preventDefault();
										handleExcelSubmit(excelTable);
									}}
								>
									Submit
								</Button>
							</>
						)}
					</Flex>
				</Col>
			</Row>
		</Form>
	);
}

export default EmployeeBulkUpdate;
